import React from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./readmodal.scss";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import cmsConfig from "../../redux/helpers/cmsConfig";

const ReadModal = (props) => {
  const navigate = useNavigate();
  const onClickWebinar = (item) => {
    let path = item.route.path.split("/");
    if (path[1] === "learn" && path.length > 2) {
      path.splice(2, 0, "webinar");
    }
    navigate("/learn/webinar/view-all", {
      state: {
        learnLandingScreenData: props.learnData.data,
        modalHelpGuides: props.helpGuides,
      },
    });
    window.scroll(0, 0);
  };

  return (
    <div className="read-modal-container">
      <div className="align-right">
        <Icons
          iconname="close-large"
          variant="icon-twenty-four-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="read-modal mt-4">
        <span className="modal-title">{props.modalTitle}</span>
        <span className="modal-button">
          <Buttons
            name="Book your place"
            className="primary"
            handleClick={() => {
              (onClickWebinar(props?.data), props.setReadModalShow(false));
            }}
          />
        </span>
      </div>
      {props.helpGuides ? (
        <div className="mt-5 me-2">
          <Row>
            <Col xs={{ span: 12, order: 1 }} md={6} lg={3}>
              <img
                height={150}
                width={230}
                alt={
                  props?.data.properties?.header?.items[0]?.content?.properties
                    ?.articleImage?.items[0]?.content?.properties
                    ?.alternateTextSingle
                }
                src={`${cmsConfig?.baseUrl}${props?.data?.properties?.header?.items[0]?.content?.properties?.articleImage?.items[0]?.content?.properties?.image[0]?.url}`}
              />
            </Col>
            <Col xs={{ span: 6, order: 1 }} md={6} lg={9}>
              {props?.data?.properties?.header?.items?.map(
                (item, index) => {
                  return (
                    <>
                      <div
                        className="modal-text ms-2"
                        key={index}
                        dangerouslySetInnerHTML={{
                          __html:
                            item.content?.properties?.articleDescription
                              ?.markup,
                        }}
                      ></div>
                    </>
                  );
                }, //eslint-disable-line
              )}
            </Col>
          </Row>
        </div>
      ) : (
        <div className="mt-5 me-2">
          <Row>
            <Col xs={{ span: 12, order: 1 }} md={6} lg={3}>
              <img
                height={150}
                width={230}
                alt={
                  props?.data.properties?.articleHeader?.items[0]?.content
                    ?.properties?.articleImage?.items[0]?.content?.properties
                    ?.alternateTextSingle
                }
                src={`${cmsConfig?.baseUrl}${props?.data?.properties?.articleHeader?.items[0]?.content?.properties?.articleImage?.items[0]?.content?.properties?.image[0]?.url}`}
              />
            </Col>
            <Col xs={{ span: 6, order: 1 }} md={6} lg={9}>
              {props?.data?.properties?.articleHeader?.items?.map(
                (item, index) => {
                  return (
                    <>
                      <div
                        className="modal-text ms-2"
                        key={index}
                        dangerouslySetInnerHTML={{
                          __html:
                            item.content?.properties?.articleDescription
                              ?.markup,
                        }}
                      ></div>
                    </>
                  );
                }, //eslint-disable-line
              )}
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default ReadModal;
